module.exports = __webpack_public_path__ + "static/img/sp18.8ad767b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp18.jpg
// module id = pyrM
// module chunks = 0